import { HStack, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Button } from 'uikit'
import { generateSequence } from './sequenceGenerator'

interface PagePaginatorProps {
  currentPage?: number
  totalPages?: number
  onPageChange: (page: number) => void
  buttonsLength?: number
}

export const PagePaginator: React.FC<PagePaginatorProps> = ({
  currentPage = 1,
  totalPages = 0,
  onPageChange,
  buttonsLength = 7,
}) => {
  const [page, setPage] = useState(currentPage)
  const sequence = generateSequence({
    total: totalPages,
    current: page,
    maxVisible: buttonsLength,
  })

  useEffect(() => {
    setPage(currentPage)
  }, [currentPage])

  return (
    <HStack>
      {sequence.map((item, index) => {
        const nextItem = sequence[index + 1]
        if (typeof item === 'number') {
          return (
            <HStack key={index}>
              <Button
                _focus={{
                  outline: 'none',
                }}
                onClick={() => {
                  setPage(item)
                  onPageChange(item)
                }}
                variant={page === item ? 'solid' : 'outline'}
              >
                {item}
              </Button>
              {nextItem >= item + 2 && <Text>. . .</Text>}
            </HStack>
          )
        }
      })}
    </HStack>
  )
}
